// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responsive-flex {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}
.responsive-flex button {
  margin: 3px 3px;
}

.pricing .col {
  padding-left: 6px;
  padding-right: 6px;
}

@media (max-width: 768px) {
  .responsive-flex {
    display: block;
  }
  .responsive-flex button {
    max-width: 82vw;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFkZC1jcmVkaXRzLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsYUFBQTtFQUNBLDZCQUFBO0VBQ0EsbUJBQUE7QUFDRjtBQUFFO0VBQ0UsZUFBQTtBQUVKOztBQUdFO0VBQ0UsaUJBQUE7RUFDQSxrQkFBQTtBQUFKOztBQUlBO0VBQ0U7SUFDRSxjQUFBO0VBREY7RUFHRTtJQUNFLGVBQUE7SUFDQSxnQkFBQTtJQUNBLHVCQUFBO0VBREo7QUFDRiIsImZpbGUiOiJhZGQtY3JlZGl0cy5jb21wb25lbnQuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5yZXNwb25zaXZlLWZsZXgge1xuICBkaXNwbGF5OiBmbGV4O1xuICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWV2ZW5seTtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgYnV0dG9uIHtcbiAgICBtYXJnaW46IDNweCAzcHg7XG4gIH1cbn1cblxuLnByaWNpbmcge1xuICAuY29sIHtcbiAgICBwYWRkaW5nLWxlZnQ6IDZweDtcbiAgICBwYWRkaW5nLXJpZ2h0OiA2cHg7XG4gIH1cbn1cblxuQG1lZGlhIChtYXgtd2lkdGg6IDc2OHB4KSB7XG4gIC5yZXNwb25zaXZlLWZsZXgge1xuICAgIGRpc3BsYXk6IGJsb2NrO1xuXG4gICAgYnV0dG9uIHtcbiAgICAgIG1heC13aWR0aDogODJ2dztcbiAgICAgIG92ZXJmbG93OiBoaWRkZW47XG4gICAgICB0ZXh0LW92ZXJmbG93OiBlbGxpcHNpcztcbiAgICB9XG4gIH1cbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/shared/ui/add-credits/add-credits.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;AACF;AAAE;EACE,eAAA;AAEJ;;AAGE;EACE,iBAAA;EACA,kBAAA;AAAJ;;AAIA;EACE;IACE,cAAA;EADF;EAGE;IACE,eAAA;IACA,gBAAA;IACA,uBAAA;EADJ;AACF;AACA,w+BAAw+B","sourcesContent":[".responsive-flex {\n  display: flex;\n  justify-content: space-evenly;\n  align-items: center;\n  button {\n    margin: 3px 3px;\n  }\n}\n\n.pricing {\n  .col {\n    padding-left: 6px;\n    padding-right: 6px;\n  }\n}\n\n@media (max-width: 768px) {\n  .responsive-flex {\n    display: block;\n\n    button {\n      max-width: 82vw;\n      overflow: hidden;\n      text-overflow: ellipsis;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
